import { memo } from 'react';
import { NavLink } from 'react-router';
import { useDrawer } from 'src/hooks/useDrawer';
import { useWindowSize } from 'src/modules/store/windowSizeStore';
import { Logo } from 'src/config/components/Logo';
import { LogoMobile } from 'src/config/components/LogoMobile';
import { useRoute } from 'src/router/hooks/useRoute';

const _HeaderLogo = () => {
  const { closeDrawer } = useDrawer();
  const { is768 } = useWindowSize('is768');
  const { ROUTE } = useRoute();

  return (
    <div className="flex justify-start 1280:justify-center items-center w-full flex-1">
      <NavLink to={ROUTE.MAIN.get()} aria-label={'main page'} onClick={closeDrawer}>
        {is768 ? (
          <Logo className="768:max-w-[190px] 768:max-h-auto max-h-10 min-w-10 max-w-10" />
        ) : (
          <LogoMobile className="768:max-w-[190px] 768:max-h-auto max-h-10 min-w-10 max-w-10" />
        )}
      </NavLink>
    </div>
  );
};

export const HeaderLogo = memo(_HeaderLogo);
